
import _ from 'lodash';
import V3GameDifficultyInstance from './v3-game-difficulty-instance.vue';

export default {
  components: {
    V3GameDifficultyInstance: V3GameDifficultyInstance
  },

  props: {
    // 当前配置
    gameConfig: {
      type: Object,
      required: true
    },
    // 当前 gameConfig 在 gameConfigResource 中的 访问路径
    keyPath: {
      type: String,
      required: true
    },
    // 当前分类的 prefix，即当前 gameConfig 在 gamaConfig 中的访问路径
    prefix: {
      type: String,
      required: true
    },
    // 如果存在配置，则按照配置来显示
    playConfig: {
      type: Object,
      required: false
    }
  },

  data: function data() {
    return {};
  },
  mounted: function mounted() {},


  methods: {
    handleChange: function handleChange(_ref) {
      var conf = _ref.conf,
          key = _ref.key;

      this.$emit('change', { conf: _.cloneDeep(conf), key: key });
    }
  }
};